import React, { useEffect, useRef, useState } from "react";
import {
  offlineStatusMessage,
  onlineAgainMessage,
  useOnlineStatus,
} from "../utils/offline";

const OfflineStatusBanner = () => {
  const isOnline = useOnlineStatus();
  const wasOfflineRef = useRef(!isOnline);
  const [showOnlineAgain, setShowOnlineAgain] = useState(false);

  useEffect(() => {
    if (!isOnline) {
      wasOfflineRef.current = true;
      setShowOnlineAgain(false);
      return undefined;
    }

    if (!wasOfflineRef.current) {
      return undefined;
    }

    setShowOnlineAgain(true);
    wasOfflineRef.current = false;
    const timeoutId = window.setTimeout(() => setShowOnlineAgain(false), 4000);

    return () => window.clearTimeout(timeoutId);
  }, [isOnline]);

  if (!isOnline) {
    return (
      <div
        className="border-b border-amber-200 bg-amber-50 px-4 py-3 text-sm font-medium text-amber-900"
        role="status"
        aria-live="polite"
      >
        {offlineStatusMessage}
      </div>
    );
  }

  if (showOnlineAgain) {
    return (
      <div
        className="border-b border-emerald-200 bg-emerald-50 px-4 py-3 text-sm font-medium text-emerald-900"
        role="status"
        aria-live="polite"
      >
        {onlineAgainMessage}
      </div>
    );
  }

  return null;
};

export default OfflineStatusBanner;
